import { Dispatch } from '../components/architecture/frontend/index'

import { gql } from '@apollo/client';
import { merge, combineLatest } from 'rxjs'
import { map, filter, startWith } from 'rxjs/operators'

import _ from 'lodash'


const GET_SIDEBAR = gql`
  query sidebar {
    sidebar {
      id            
      title            
      icon           
      view           
      type          
      onClickAction   
      onClickValue    
      count     
      bold          
      spaced           
      placeholder     
      order           
    }
  }
`;

combineLatest(
  Dispatch.getState('user.email'),
   merge(
    Dispatch.getState('shipments.rawData'), 
    Dispatch.getState('shipment.id'),
    Dispatch.getAction('Response.sendToSupplier'),
    Dispatch.getAction('Response.sendRefereeShipments'),
    Dispatch.getAction('Response.sendSettlement'),
    Dispatch.getAction('Response.sendDenied'),
    Dispatch.getAction('Response.shipments.delete'),
    Dispatch.getAction('Response.saveShipments'),
    Dispatch.getAction('Response.shipment'),
  ).pipe(
    startWith(0)
  )
)
  .pipe(
  )
  .subscribe(([user, shipment]) => {
    if (_.isNil(user)) {
      Dispatch.nextState('sidebar', null)
    }
    else {
      //Dispatch.nextState('sidebar', 'loading')
      Dispatch.nextAction('Request.sidebar', { type: 'query', query: GET_SIDEBAR, variables: { }, poll: process.env.REACT_APP_POLL_INTERVAL,  retry: process.env.REACT_APP_RETRY_INTERVAL })
    }
  })

Dispatch.getAction('Response.sidebar')
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.sidebar)
  )
  .subscribe(e => Dispatch.nextState('sidebar', e))